// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PmHpY","delete":"styles_delete__OdyyQ","update":"styles_update__3yO2X","add":"styles_add__1CQHG"};